import React from 'react'

export default function Ring() {
    return <div className='bubble-ring'>
        <img alt="ring" className='bubble-icon-shake' src={process.env.PUBLIC_URL + "/img/ring.png"} width={30}/>
    </div>
}
